var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Login"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4445 13.5H10.7223M10.7223 13.5L14.889 17.6666M10.7223 13.5L14.889 9.33331",
    stroke: "#666565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4444 5.16667V3.77778C20.4444 2.24365 19.2008 1 17.6667 1H3.77778C2.24365 1 1 2.24365 1 3.77778V23.2222C1 24.7564 2.24365 26 3.77778 26H17.6667C19.2008 26 20.4444 24.7564 20.4444 23.2222V21.8333",
    stroke: "#666565",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.60b7437a98e35f683322fed76cb50abf.svg";
export { ForwardRef as ReactComponent };